module.exports = __webpack_public_path__ + "img/whiterefresh.4286e5b5.svg";